export interface WorkCasenotesModel {
    WorkId: string;
    Id: number ;
    CasenoteDate: string;
    User: number;
    CasenoteType: string ;
    TypeName: string;
    Detail: string;
}

export class WorkCasenotesFrameModel {
    count : number ;
    page : number ;
    pagesize : number ;
    data : WorkCasenotesModel[] ;
}

export class WorkCasenotesDtoModel {
    "@odata.context" : number ;
    "@odata.count" : number ;
    value : WorkCasenotesModel[] ;
}
